import {
    PLANOGRAM_FETCHING,
    PLANOGRAM_ERROR,
    PLANOGRAM_FETCHED,
    PLANOGRAM_SAVING,
    PLANOGRAM_SAVED,
    PLANOGRAM_DELETED,
    PLANOGRAM_DELETING,
} from './../actions/planogram.js';

const initplanogramState = {
    isFetching: false,
    error: null,
    data: null,
    saving: false,
    isSaved: false,
    isDeleted: false,
    deleting: false,
};

export const Planograms = (state = initplanogramState, action) => {
    switch (action.type) {
        case PLANOGRAM_FETCHING:
            return {
                ...state,
                error: null,
                data: null,
                isFetching: true,
            };
        case PLANOGRAM_FETCHED:
            return {
                ...state,
                error: null,
                isFetching: false,
                isDeleted: false,
                data: action.data,
            };
        case PLANOGRAM_ERROR:
            return {
                ...state,
                isFetching: false,
                error: action.error,
            };
        case PLANOGRAM_SAVING:
            return {
                ...state,
                saving: true,
            };
        case PLANOGRAM_SAVED:
            return {
                ...state,
                data: action.data,
                saving: false,
                isSaved: true,
                isDeleted: false,
            };
        case PLANOGRAM_DELETED:
            return {
                ...state,
                deleting: false,
                isDeleted: true,
                data: null,
            };
        case PLANOGRAM_DELETING:
            return {
                ...state,
                isDeleted: false,
                deleting: true,
            };
        default:
            return state;
    }
};

export default Planograms;
